// extracted by mini-css-extract-plugin
module.exports = {"fullSize":"ComEvent__full-size--nYjEM1hI"};